/**
 * @fileoverview Molecule: what a list shows when it holds nothing.
 * @module components/molecules/EmptyState
 */

import "./EmptyState.css"

/** Props accepted by {@link EmptyState}. */
export interface EmptyStateProps {
	/** Short headline. */
	readonly title: string
	/** What the user can do about it. */
	readonly message: string
}

/**
 * Empty-collection placeholder.
 *
 * @param props - Title and guidance.
 * @returns The rendered placeholder.
 */
export function EmptyState({ title, message }: EmptyStateProps) {
	return (
		<div className="empty">
			<p className="empty__title">{title}</p>
			<p className="empty__message">{message}</p>
		</div>
	)
}
